module.exports = __webpack_public_path__ + "img/744.ccef4abb.jpg";